export const DATA_HOOKS = {
  ADD_ITEM: 'add-item',
  TEXT: 'text',
};
